var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Rx from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { DatastoreDocument } from './datastore-document';
var DatastoreCollection = /** @class */ (function () {
    function DatastoreCollection(ref$, storeBackend, status$, valueChanges$) {
        this.ref$ = ref$;
        this.storeBackend = storeBackend;
        this.status$ = status$;
        this.valueChanges$ = valueChanges$;
    }
    DatastoreCollection.prototype.valueChanges = function () {
        return this.valueChanges$;
    };
    DatastoreCollection.prototype.push = function (object) {
        var _this = this;
        return this.ref$
            .pipe(take(1), switchMap(function (ref) { return _this.storeBackend.push(ref, object); }))
            .toPromise();
    };
    DatastoreCollection.prototype.set = function (id, object) {
        var _this = this;
        return this.ref$
            .pipe(take(1), switchMap(function (ref) { return _this.storeBackend.set(ref, id, object); }))
            .toPromise();
    };
    DatastoreCollection.prototype.update = function (id, delta) {
        var _this = this;
        return this.ref$
            .pipe(take(1), switchMap(function (ref) { return _this.storeBackend.update(ref, id, delta); }))
            .toPromise();
    };
    DatastoreCollection.prototype.remove = function (id) {
        var _this = this;
        return this.ref$
            .pipe(take(1), switchMap(function (ref) { return _this.storeBackend.delete(ref, id); }))
            .toPromise();
    };
    DatastoreCollection.prototype.toDatastoreDocumentList = function () {
        var _this = this;
        return this.valueChanges$.pipe(map(function (collections) {
            return collections.map(function (collection) {
                return new DatastoreDocument(_this.ref$.pipe(map(function (ref) { return ({
                    path: __assign({}, ref.path, { ids: [collection.id.toString()] }),
                }); })), _this.storeBackend, _this.status$, Rx.of(collection));
            });
        }));
    };
    return DatastoreCollection;
}());
export { DatastoreCollection };
